import { apiFetch } from '../apiFetch'

export interface IssueSlipLineItem {
  id: string
  issue_slip_id: string
  kind: 'MATERIAL' | 'FREE'
  material_id?: string | null
  free_stock_item_id?: string | null
  label_snapshot: string
  details_snapshot?: any
  qty: number
  uom: string
  note?: string | null
}

export interface IssueSlipListItem {
  id: string
  code: string
  purpose: string
  created_by: string
  created_by_name?: string | null
  created_at: string
  note?: string | null
  status: 'ACTIVE' | 'VOID'
  idempotency_key: string
  voided_at?: string | null
  void_reason?: string | null
  line_count?: number
  /** Vật tư xuất trong phiếu (tên, số lượng, ĐVT) để hiện và tìm ngay ở danh sách. */
  line_items?: Array<{ name: string; qty: number; uom: string }>
}

export interface IssueSlipDetail extends IssueSlipListItem {
  lines: IssueSlipLineItem[]
}

export interface CreateIssueSlipLineInput {
  kind: 'MATERIAL' | 'FREE'
  material_id?: string
  free_stock_item_id?: string
  qty: number
  note?: string
}

export interface CreateIssueSlipPayload {
  purpose: string
  note?: string
  lines: CreateIssueSlipLineInput[]
}

export async function listIssueSlips(): Promise<IssueSlipListItem[]> {
  const res = await apiFetch('/api/issue-slips')
  const body = await res.json()
  if (!res.ok || !body.ok) {
    throw new Error(body?.error?.message || 'Không thể tải danh sách phiếu xuất kho')
  }
  return (body.data || []).map((row: any) => ({
    ...row,
    line_count: Number(row.line_count ?? 0),
  }))
}

export async function getIssueSlip(id: string): Promise<IssueSlipDetail> {
  const res = await apiFetch(`/api/issue-slips/${id}`)
  const body = await res.json()
  if (!res.ok || !body.ok) {
    throw new Error(body?.error?.message || 'Không thể tải chi tiết phiếu xuất kho')
  }
  const item = body.data
  return {
    ...item,
    lines: (item.lines || []).map((l: any) => ({
      ...l,
      qty: Number(l.qty ?? 0),
    })),
  }
}

export async function createIssueSlip(
  payload: CreateIssueSlipPayload,
  idempotencyKey: string,
): Promise<IssueSlipDetail> {
  const res = await apiFetch('/api/issue-slips', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Idempotency-Key': idempotencyKey,
    },
    body: JSON.stringify(payload),
  })
  const body = await res.json()
  if (!res.ok || !body.ok) {
    const err: any = new Error(body?.error?.message || 'Lỗi khi tạo phiếu xuất kho')
    err.code = body?.error?.code
    err.status = res.status
    throw err
  }
  const item = body.data
  return {
    ...item,
    lines: (item.lines || []).map((l: any) => ({
      ...l,
      qty: Number(l.qty ?? 0),
    })),
  }
}

export async function voidIssueSlip(id: string, reason: string): Promise<IssueSlipDetail> {
  const res = await apiFetch(`/api/issue-slips/${id}/void`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ reason }),
  })
  const body = await res.json()
  if (!res.ok || !body.ok) {
    const err: any = new Error(body?.error?.message || 'Lỗi khi hủy phiếu xuất kho')
    err.code = body?.error?.code
    err.status = res.status
    throw err
  }
  const item = body.data
  return {
    ...item,
    lines: (item.lines || []).map((l: any) => ({
      ...l,
      qty: Number(l.qty ?? 0),
    })),
  }
}
